import * as React from 'react';
export default function useId(id) {
  const generatedId = React.useMemo(() => id || "tangram-".concat(Math.round(Math.random() * 1e6)), [id]);
  return generatedId;
}